// Updates the product card price in listings whenever a color swatch is selected.
document.addEventListener('change', (event) => {
  const input = event.target;

  if (!(input instanceof HTMLInputElement) || !input.matches('.product-card__swatch-list [type="radio"]')) {
    return;
  }

  const priceHtml = input.getAttribute('data-variant-price-html');

  if (!priceHtml) {
    return;
  }

  const card = input.closest('product-card');
  const priceList = card?.querySelector('.product-card__info price-list');

  if (!priceList) {
    return;
  }

  priceList.outerHTML = priceHtml;

  // Keep the omnibus (Sniffie) price in sync with the selected variant.
  const omnibusHtml = (input.getAttribute('data-variant-omnibus-html') || '').trim();
  const priceContainer = card.querySelector('.product-card__info price-list')?.parentElement;
  const existingOmnibus = card.querySelector('.product-card__info #sniffie-omnibus-price');

  if (omnibusHtml) {
    if (existingOmnibus) {
      existingOmnibus.outerHTML = omnibusHtml;
    } else if (priceContainer) {
      priceContainer.insertAdjacentHTML('afterend', omnibusHtml);
    }
  } else if (existingOmnibus) {
    existingOmnibus.remove();
  }
});
